import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACForbiddenError = ({
  'data-test-id': dataTestId = 'forbidden-error',
  href,
  to = '/'
}) => /*#__PURE__*/_jsxs(ErrorMessage, {
  "data-test-id": dataTestId,
  illustration: "lock",
  title: /*#__PURE__*/_jsx(H4, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.forbidden.heading"
    })
  }),
  type: "403",
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.forbidden.subheading"
    })
  }), href ? /*#__PURE__*/_jsx(Button, {
    href: href,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.button"
    })
  }) : /*#__PURE__*/_jsx(RouterButton, {
    to: to,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.button"
    })
  })]
});
export default ACForbiddenError;